import { render } from "./Questions.vue?vue&type=template&id=7e1d774a"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
script.render = render

export default script